import { LineLayerSpecification } from 'mapbox-gl';

export const ROAD_MAP_TYPE = 'roadmap';
export const SATELLITE_MAP_TYPE = 'satellite';

export const MAP_CONFIGURATION = {
  [ROAD_MAP_TYPE]: {
    style: 'mapbox://styles/mapbox/streets-v12',
  },
  [SATELLITE_MAP_TYPE]: {
    style: 'mapbox://styles/mapbox/satellite-streets-v12',
  },
};

export const TRAFFIC_LAYER_STYLE: LineLayerSpecification = {
  id: 'traffic',
  source: 'mapbox-traffic',
  'source-layer': 'traffic',
  type: 'line',
  paint: {
    'line-width': 1.5,
    'line-color': [
      'case',
      ['==', 'low', ['get', 'congestion']],
      '#aab7ef',
      ['==', 'moderate', ['get', 'congestion']],
      '#4264fb',
      ['==', 'heavy', ['get', 'congestion']],
      '#ee4e8b',
      ['==', 'severe', ['get', 'congestion']],
      '#b43b71',
      '#000000',
    ],
  },
};

export const INITIAL_VIEW_STATE = {
  longitude: -100.38806,
  latitude: 20.58806,
  zoom: 14,
};
